export default {
  searchPlaceholder: 'Search...',
  refresh: 'Refresh',
} as const;
